module.exports = {
    /**
     *
     * @param $month - [0,11]
     * @param $year - 2017
     * @returns {number}
     */
    getMonthDaysCount: ($month, $year) => {
        return new Date($year, $month + 1, 0).getDate();
    },

    getMonthsBetweenDates: (date1, date2) => {
        return (date2.getYear() - date1.getYear()) * 12
            + date2.getMonth() - date1.getMonth()
            + (date2.getDate() - date1.getDate()) / module.exports.getMonthDaysCount(date2.getMonth(), date2.getYear());
    },

    getTodayStringDate: () => {
        return module.exports.getStringDate(new Date());
    },

    getStringDate: (date) => {
        return [
            date.getFullYear(),
            (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1),
            (date.getDate() < 10 ? '0' : '') + date.getDate()
        ].join('-');
    }
};